import type { ReactNode } from 'react';
import { useEffect } from 'react';

export interface DialogProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  /** Breite Variante für reichhaltige Overlays (z. B. Aufgaben-Detail). */
  wide?: boolean;
  'aria-label': string;
}

/**
 * Leichtgewichtiger Dialog: Backdrop-Klick und Escape schließen.
 * Bewusst ohne Portal — die Shell rendert ihn an oberster Ebene.
 */
export function Dialog({ open, onClose, children, wide, 'aria-label': ariaLabel }: DialogProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="au-dialog-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className={`au-dialog${wide === true ? ' au-dialog--wide' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
      >
        {children}
      </div>
    </div>
  );
}
